import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import type { OptionProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import type { FieldDataType } from '@feathr/blackbox';
import type { ISelectOption } from '@feathr/components';
import { fieldDataTypeIcon } from '@feathr/extender/styles/fieldDataType';

function DataTypeOption(props: OptionProps<ISelectOption>): JSX.Element {
  const { data } = props;

  const icon = data.id === 'create' ? faPlus : fieldDataTypeIcon(data.id as FieldDataType);

  return (
    <components.Option {...props}>
      {icon && <FontAwesomeIcon icon={icon} />}
      {data.name}
    </components.Option>
  );
}

export default DataTypeOption;
